'use strict';

var d3 = require('d3');

var drawUtils = {
	tweenTime: 500,
	colors: {
		signals: { neutral: '#1474A4', good: '#5F9920', warningLow: '#fce290', warning: '#ebb626', warningHigh: '#de7510', alert: '#a63d21', na: '#d8d8d8', missing: '#f5f5f5' },
		similarPatients: { default: '#1474A4', selected: '#1C255C', deSelected: '#d8d8d8', activePatient: '#de7510', filter: '#9C3790', NA: '#d8d8d8' },
		sequential: {
			blues: ['#0A0C1E', //0
			'#1C255C', //1
			'#1C417A', //2
			'#1B578E', //3
			'#1474A4', //4
			'#5DAFD1', //5
			'#9DD3E3', //6
			'#DAF1F7'],
			purples: ['#160718', //0
			'#401442', //1
			'#5E1A54', //2
			'#82236F', //3
			'#9C3790', //4
			'#B35BB2', //5
			'#C48CD4', //6
			'#D6B9E6'],
			oranges: ['#14D192B', //0
			'#6E202D', //1
			'#923323', //2
			'#BA4C1E', //3
			'#DE7510', //4
			'#E6A219', //5
			'#F2C544', //6
			'#FCE290'],
			palletes: {
				'pIndex1': [4],
				'pIndex2': [2, 4],
				'pIndex3': [2, 4, 6],
				'pIndex4': [1, 2, 4, 6],
				'pIndex5': [1, 2, 4, 6, 7],
				'pIndex6': [1, 2, 4, 5, 6, 7],
				'pIndex7': [1, 2, 3, 4, 5, 6, 7],
				'pIndex8': [0, 1, 2, 3, 4, 5, 6, 7]
			}

		},
		defaultColorScheme: { type: 'sequential', range: 'blues' },
		diverging: {
			bluePurple: ['#1C255C', '#1D4C84', "#1474A4", '#E04A71', '#AD1C57', '#5C0C3C']
		},
		qualitative: {
			bluePurple: ['#1C5385', '#79C8C6', "#1474A4", '#F2C544', '#D13B66', '#5C0C3C']
		},
		interpolators: ["Blues", "Oranges", "Greens", "Reds", "BuGn", "BuPu", "GnBu", "OrRd", "PuBuGn", "PuBu", "PuRd", "RdPu"],

		scatterPlot: { default: '#012964' }
	}
};

drawUtils.colors.diverging.bluePurple.reverse();

drawUtils.generatePallete = function (type, range, pIndex) {

	var collorPallete = [];
	for (var i = 0; i < pIndex; i++) {
		var colorIndex = null;
		if (drawUtils.colors[type].palletes['pIndex' + pIndex]) colorIndex = drawUtils.colors[type].palletes['pIndex' + pIndex][i];

		var c = void 0;
		if (!colorIndex) {
			c = '#' + (0x1000000 + Math.random() * 0xffffff).toString(16).substr(1, 6);
		} else {
			c = drawUtils.colors[type][range][colorIndex];
		}

		collorPallete.push(c);
	}

	return collorPallete;
};

drawUtils.computeTextNodeRect = function (textNode, offsetW, maxWidth, alignElements) {

	var bbox = textNode.node().getBBox();
	var calcWidth = bbox.width + offsetW;

	// show max-height and wrap text if width exceeds it
	if (calcWidth > maxWidth) {
		calcWidth = maxWidth;
		textNode.call(drawUtils.splitTextNode, calcWidth);
	}

	// set height of the alignElements by the height of the text element
	var clientRect = textNode.node().getBoundingClientRect();
	var clientHeight = clientRect.height + 7;

	for (var i = 0; i < alignElements.length; i++) {
		alignElements[i].attr('width', calcWidth + 20 + "px").attr('height', clientHeight + "px");
	}

	return { width: calcWidth, height: clientHeight };
};

drawUtils.splitTextNode = function (textNode, width) {
	textNode.each(function () {
		var text = d3.select(this),
		    words = text.text().split(/\s+/).reverse(),
		    word = void 0,
		    line = [],
		    lineNumber = 0,
		    lineHeight = 1.1,
		    // ems
		x = text.attr("x"),
		    y = text.attr("y"),
		    dy = 1.1,
		    dyOffset = 0,
		    // align text to the top of the box
		tspan = text.text(null).append("tspan").attr("x", x).attr("y", y).attr("dy", dyOffset + "em");
		while (word = words.pop()) {
			line.push(word);
			tspan.text(line.join(" "));
			if (tspan.node().getComputedTextLength() > width) {
				line.pop();
				tspan.text(line.join(" "));
				line = [word];
				lineNumber++;
				tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", (lineNumber - 1) * lineHeight + dy + dyOffset + "em").text(word);
			}
		}
	});
};

module.exports = drawUtils;